import { render, staticRenderFns } from "./ExpiringInventory.vue?vue&type=template&id=921b880a"
import script from "./ExpiringInventory.vue?vue&type=script&lang=js"
export * from "./ExpiringInventory.vue?vue&type=script&lang=js"
import style0 from "./ExpiringInventory.vue?vue&type=style&index=0&id=921b880a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports